// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3NMAf","header":"MergedInvoice_header__1mcrV"};